import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { MenuItem } from 'primeng/api';

/**
 * Drop-in replacement for p-tabMenu on detail pages: same MenuItem model,
 * runs `item.command` then emits `activeChange` (p-tabMenu order).
 */
@Component({
  selector: 'app-detail-tabs',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <nav class="pp-hub-tabs pp-detail-tabs" role="tablist" [attr.aria-label]="ariaLabel">
      <ng-container *ngFor="let item of items">
        <button
          *ngIf="item.visible !== false"
          type="button"
          role="tab"
          class="pp-hub-tab"
          [class.active]="isActive(item)"
          [attr.aria-selected]="isActive(item)"
          [disabled]="item.disabled"
          (click)="select(item, $event)">
          <i *ngIf="item.icon" [class]="item.icon"></i>
          <span>{{ item.label }}</span>
          <span *ngIf="item.badge" class="pp-hub-tab__badge">{{ item.badge }}</span>
        </button>
      </ng-container>
    </nav>
  `,
  styles: [':host { display: block; min-width: 0; }'],
})
export class DetailTabsComponent {
  @Input() items: MenuItem[] | null | undefined = [];
  @Input() active: MenuItem | null | undefined = null;
  @Input() ariaLabel = 'Sections';
  @Output() activeChange = new EventEmitter<MenuItem>();

  isActive(item: MenuItem): boolean {
    if (!this.active) return false;
    if (this.active === item) return true;
    if (item.id && this.active.id) return item.id === this.active.id;
    return !!item.label && item.label === this.active.label;
  }

  select(item: MenuItem, event: MouseEvent): void {
    if (item.disabled || this.isActive(item)) return;
    item.command?.({ originalEvent: event, item });
    this.active = item;
    this.activeChange.emit(item);
  }
}
